import { List, Skeleton, Stack } from "@mui/material";
import Grid from "@mui/material/Grid";
import { UserContext } from "components/context/UserProvider";
import useQueryStringState from "components/hooks/useQueryStringState";
import Pagination from "components/ui/atoms/Pagination";
import FilterAndSort from "components/ui/molecules/FilterAndSort";
import Layout from "components/ui/molecules/Layout";
import AsyncProcessListItem from "models/async_processes/AsyncProcessListItem";
import AsyncProcessesFilterForm from "models/async_processes/AsyncProcessesFilterForm";
import AsyncProcesesSortForm from "models/async_processes/AsyncProcessesSortForm";
import {
  useAllAsyncProcesses,
  useRetryAsyncProcess,
} from "models/async_processes/apiAsyncProcesses";
import AutomatedTasksHeader from "models/automated_tasks/AutomatedTasksHeader";
import { useContext } from "react";

const AutomatedTasks = () => {
  const [state, setState] = useQueryStringState();
  const { user } = useContext(UserContext);
  const { mutateAsync: mutateCreateAsyncProcesses } = useRetryAsyncProcess();
  const {
    data: automatedTasks,
    isLoading: automatedTasksIsLoading,
    isError: automatedTasksIsError,
    refetch,
  } = useAllAsyncProcesses({
    ...state.filter,
    ...state.sort,
    offset: state.offset,
    search: state.search,
  });

  const handleRestart = (automatedTask) => {
    mutateCreateAsyncProcesses({
      process_code: automatedTask.process_code,
      args: automatedTask.args,
      user_id: user.id,
    }).then(() => {
      refetch();
    });
  };

  const automatedTasksSkeleton = (
    <Stack spacing={2}>
      <Skeleton variant="rectangular" height={150} />
      <Skeleton variant="rectangular" height={150} />
      <Skeleton variant="rectangular" height={150} />
    </Stack>
  );

  if (automatedTasksIsError) return <>Error</>;

  return (
    <Layout container hideBreadcrumbs>
      <AutomatedTasksHeader onCreated={refetch} />
      <Layout content>
        <FilterAndSort
          FilterForm={AsyncProcessesFilterForm}
          SortForm={AsyncProcesesSortForm}
          state={state}
          setState={setState}
          count={automatedTasks?.count}
        />
      </Layout>
      <Layout content>
        {automatedTasksIsLoading ? (
          automatedTasksSkeleton
        ) : (
          <>
            <List variant="boxed">
              {automatedTasks.results.map((automatedTask, index) => (
                <AsyncProcessListItem
                  automatedTask={automatedTask}
                  handleRestart={handleRestart}
                  key={index}
                />
              ))}
            </List>
            <Grid container alignItems="center" justifyContent="center" mt={4}>
              <Pagination
                offset={state.offset || 0}
                setOffset={(offset) => {
                  setState({
                    ...state,
                    offset: offset,
                  });
                }}
                count={automatedTasks.count}
              />
            </Grid>
          </>
        )}
      </Layout>
    </Layout>
  );
};

export default AutomatedTasks;
